import React, { createContext, useState, useEffect } from "react";
import Axios from "axios";
import { apiRoutes, baseUrl, environment } from "./apiRoute";
import { message } from "antd";
import moment from "moment";

const UserContext = createContext();

const UserContextProvider = (appProps) => {
  // the value that will be given to the context
  const [profileNeeded, setProfileComplete] = useState(true);
  const [pageId, setPageId] = useState(0);
  const [isLoading, setLoading] = useState(true);
  const [jobs, setJobs] = useState({});
  const [settingData, setSettingData] = useState();

  const [roles, setRoles] = useState();
  const [view, setView] = useState("candidate");
  const [isEmployer, setEmployer] = useState(false);
  const [user, setUser] = useState();
  const [hotels, setHotels] = useState();
  const [loadingNewPage, setLoadingNewPage] = useState(false);
  const [nominationsData, setNominations] = useState();

  // let mounted = false;
  // useEffect(() => {
  //   if (!mounted) {
  //     getHotels();
  //     checkRole();
  //   }

  //   return () => {
  //     mounted = true;
  //   };
  // }, []);
  useEffect(() => {
    // getNominations();
  }, []);
  useEffect(() => {
    addPageId();
  }, [loadingNewPage]);

  const addPageId = () => {
    setPageId(pageId + 1);
  };
  const getHotels = async () => {};
  const checkRole = async () => {};
  const getNominations = async () => {
    console.log("get nominations");
    try {
      const response = await Axios.post(apiRoutes[environment].nominations);

      if (response.status == 200) {
        var nominations = response.data;
        nominations = nominations
          .map((item) => {
            return { ...item, ...{ key: item._id } };
          })
          .filter((item) => item.term == moment().year());

        setNominations(nominations);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
  };
  return (
    // the Provider gives access to the context to its children
    <UserContext.Provider
      value={{
        hotels,
        user,
        setUser,
        pageId,
        addPageId,
        settingData,
        isLoading,
        setLoading,

        view,
        setView,
        isEmployer,

        profileNeeded,
        jobs,

        loadingNewPage,
        setLoadingNewPage,
        nominationsData,
      }}
    >
      {appProps.children}
    </UserContext.Provider>
  );
};

export { UserContext, UserContextProvider };
